import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Lock: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4 9.6087V4.82609C17.4 2.713 15.7882 1 13.8 1H10.2C8.21177 1 6.6 2.713 6.6 4.82609V9.6087M3 12.4783C3 10.8934 4.20883 9.6087 5.7 9.6087H18.3C19.7912 9.6087 21 10.8934 21 12.4783V20.1304C21 21.7153 19.7912 23 18.3 23H5.7C4.20883 23 3 21.7153 3 20.1304V12.4783Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M12 15V18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Lock;
